export const screenInfo = {
  VIEW: ["Standard TrOOP Schedule Step Detail", "RCSBD002"],
};

export const formFields = [
  {
    section: "General Information",
    label: "Schedule",
    name: "sbsScheduleName",
    type: "text",
    nextGenType: "Text",
    nextGenUILabel: "Schedule",
    length: 10,
    position: [1, 1],
    attributes: "Read-Only",
    dropdownCondition: "-",
    values: "-",
    mode: "Display-Only",
    fieldNature: "View: Read-only",
  },
  {
    section: "General Information",
    label: "Description",
    name: "sbsScheduleDesc",
    type: "text",
    nextGenType: "Text",
    nextGenUILabel: "Description",
    length: 25,
    position: [2, 1],
    attributes: "Read-Only",
    dropdownCondition: "-",
    values: "-",
    mode: "Display-Only",
    fieldNature: "View: Read-only",
  },
  {
    fieldLabel: "TSD Coverage Level",
    label: "Coverage Level",
    name: "sbdCoverageLevel",
    type: "dropdown",
    nextGenType: "Text",
    nextGenUILabel: "Coverage Level",
    length: 1,
    position: [3, 1],
    attributes: "Read-Only",
    dropdownCondition: "Valid Values",
    values: "Valid Values",
    mode: "Display-Only",
    fieldNature: "View: Read-only",
  },
  {
    label: "TrOOP Maximum Amount",
    name: "sbdTroopAmount",
    type: "number",
    fractionDigits: 2,
    nextGenType: "Numeric",
    nextGenUILabel: "TrOOP Maximum Amount",
    length: "9,2",
    position: [4, 1],
    attributes: "Read-Only",
    dropdownCondition: "-",
    values: "-",
    mode: "Display-Only",
    fieldNature: "View: Read-only",
  },
  {
    label: "Drug Spend Maximum Amount",
    name: "sbdDrugSpend",
    type: "number",
    fractionDigits: 2,
    nextGenType: "Numeric",
    nextGenUILabel: "Drug Spend Maximum Amount",
    length: "9,2",
    position: [5, 1],
    attributes: "Read-Only",
    dropdownCondition: "-",
    values: "-",
    mode: "Display-Only",
    fieldNature: "View: Read-only",
    displayConditions: [
      {
        dependentField: "sbdDrugSpend",
        dependentFieldValues: [null],
        fieldNature: "Non-Display",
        shouldFieldValuesIncluded: true,
      },
    ],
  },
  {
    section: "Member Cost Share (Header)",
    label: "Standard",
    name: "sbdMbCostShareStandrd",
    type: "number",
    fractionDigits: 2,
    nextGenType: "Numeric",
    nextGenUILabel: "Standard",
    length: "5,2",
    position: [6, 1],
    attributes: "Read-Only",
    dropdownCondition: "-",
    values: "-",
    mode: "Display-Only",
    fieldNature: "View: Read-only",
    displayConditions: [
      {
        dependentField: "sbdMbCostShareStandrd",
        dependentFieldValues: [null],
        fieldNature: "Non-Display",
        shouldFieldValuesIncluded: true,
      },
    ],
  },
  {
    section: "Member Cost Share (Header)",
    label: "Dual PACE",
    name: "sbdMbCostShareDulPac",
    type: "number",
    fractionDigits: 2,
    nextGenType: "Numeric",
    nextGenUILabel: "Dual Pac",
    length: "5,3",
    position: [7, 1],
    attributes: "Read-Only",
    dropdownCondition: "-",
    values: "-",
    mode: "Display-Only",
    fieldNature: "View: Read-only",
    displayConditions: [
      {
        dependentField: "sbdMbCostShareDulPac",
        dependentFieldValues: [null],
        fieldNature: "Non-Display",
        shouldFieldValuesIncluded: true,
      },
    ],
  },

  {
    section: "CPP Amount (Header)",
    Layout: "Table Format",
    label: "Brand",
    type: "label",
    position: [8, 1],
    displayConditions: [
      {
        dependentField: "sbsCppCatBrandAmt",
        dependentFieldValues: [null],
        fieldNature: "Non-Display",
        shouldFieldValuesIncluded: true,
      },
    ],
  },
  {
    section: "CPP Amount (Header)",
    Layout: "Table Format",
    label: "Generic",
    type: "label",
    position: [10, 1],
    displayConditions: [
      {
        dependentField: "sbsCppCatGenericAmt",
        dependentFieldValues: [null],
        fieldNature: "Non-Display",
        shouldFieldValuesIncluded: true,
      },
    ],
  },

  // { label: 'DS-', name: 'ZDPTTX', type: 'text', nextGenType: 'Text', nextGenUILabel: 'DS-', length: 3, position: '15,2', attributes: 'Read-Only', dropdownCondition: '-', values: '-', mode: 'Display-Only', fieldNature: 'View: Read-only' },
  {
    section: "CPP Amount (Header)",
    name: "sbsCppCatBrandAmt",
    type: "number",
    fractionDigits: 2,
    nextGenType: "Numeric",
    label: "DS-",
    length: "7,2",
    position: [9, 1],
    attributes: "Read-Only",
    dropdownCondition: "-",
    values: "-",
    mode: "Display-Only",
    fieldNature: "View: Read-only",
    displayConditions: [
      {
        dependentField: "sbsCppCatBrandAmt",
        dependentFieldValues: [null],
        fieldNature: "Non-Display",
        shouldFieldValuesIncluded: true,
      },
    ],
  },
  // { label: 'DS-', name: 'ZDGRIN', type: 'text', nextGenType: 'Text', nextGenUILabel: 'DS-', length: 3, position: '15,217', attributes: 'Read-Only', dropdownCondition: '-', values: '-', mode: 'Display-Only' },
  {
    section: "CPP Amount (Header)",
    name: "sbsCppCatGenericAmt",
    type: "number",
    fractionDigits: 2,
    nextGenType: "Numeric",
    label: "DS-",
    length: "7,2",
    position: [11, 1],
    attributes: "Read-Only",
    dropdownCondition: "-",
    values: "-",
    mode: "Read-Only",
    fieldNature: "View: Read-only",
    displayConditions: [
      {
        dependentField: "sbsCppCatGenericAmt",
        dependentFieldValues: [null],
        fieldNature: "Non-Display",
        shouldFieldValuesIncluded: true,
      },
    ],
  },
  {
    section: "CPP Amount (Header)",
    name: "sbsCppCatPercent",
    type: "number",
    fractionDigits: 2,
    nextGenType: "Numeric",
    label: "%",
    nextGenUILabel: "--%--",
    length: "5,2",
    position: [12, 1],
    attributes: "Read-Only",
    dropdownCondition: "-",
    values: "-",
    mode: "Display-Only",
    fieldNature: "View: Read-only",
    displayConditions: [
      {
        dependentField: "sbsCppCatPercent",
        dependentFieldValues: [null],
        fieldNature: "Non-Display",
        shouldFieldValuesIncluded: true,
      },
    ],
  },
];
